import * as React from "react";
import styles from "@styles/pages/consumer-care/category-question.module.scss";
import SILink from "@components/link/silink";
import DidntGetTheAnswerYou from "@components/consumer-care/dont-get-your-answer";
import {strapi} from "@api/Strapi";
import Head from "next/head";
import {YouMayAlsoLikeHoneyList} from "@components/you-may-also-like-honey-list";
import qs from "qs";


// @ts-ignore
function ConsumerCareCategoryQuestionAnswer({FAQ, faqStructuredData, relatedProducts}) {

    /**
     * Contain footer component
     * view all faq button user can see all category, and print topic can print current page
     * if not found any related then they can contact us
     */
    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{__html: JSON.stringify(faqStructuredData)}}
                />
            </Head>
            <section className={styles.question_answer}>
                <h1>{FAQ.Question}</h1>
                <span>Views: {FAQ.Views ? FAQ.Views : 0}</span>
                <div className={'answer'} dangerouslySetInnerHTML={{__html: FAQ.Answer}}></div>
                <div className={'other_links'}>
                    <SILink classes={'print_topic'} href={'#!'} onClick={() => {
                        window.print();
                    }}>print topic</SILink>
                    <SILink classes={'view_all_faq'} href={'/consumer-care-all-faq'}>view all faq<span>s</span></SILink>
                </div>

            </section>
            <hr className={styles.hr}/>
            {/* Other Related Products */}
            <YouMayAlsoLikeHoneyList title={'you may also try'} honeyList={relatedProducts}></YouMayAlsoLikeHoneyList>
            <DidntGetTheAnswerYou></DidntGetTheAnswerYou>
        </>
    )
}

export async function getServerSideProps(context: {
    params: { category: any; question: string; };
    resolvedUrl: string;
}) {

    const category = context.params.category;
    const question = context.params.question;

    let response = await strapi.getFaqList(`filters[Link][$eqi]=${question}&filters[Board][Link][$eqi]=${category}`);
    if (response.status == 200 && response.data && response.data.data && response.data.data.length > 0) {

        try {
            let totalViews = response.data.data[0].attributes.Views == null ? 0 : parseInt(response.data.data[0].attributes.Views)
            await strapi.getUpdateFaqView(response.data.data[0].id, {data: {Views: totalViews + 1}})
            response.data.data[0].attributes.Views = (totalViews + 1);
        } catch (e) {
            console.log(e)
        }

        let seoDetails: any = {
            title: `${response.data.data[0].attributes.SEO_Title ? response.data.data[0].attributes.SEO_Title : response.data.data[0].attributes.Question} | SIDR®`,
            url: context.resolvedUrl,
            description: response.data.data[0].attributes.SEO_Description,
            keyword: response.data.data[0].attributes.SEO_Keyword,
        };
        if (response.data.data[0].attributes.SEO_Image.data) {
            seoDetails['image'] = response.data.data[0].attributes.SEO_Image.data.attributes.url;
            seoDetails['imageAlt'] = response.data.data[0].attributes.SEO_Image.data.attributes.alternativeText;
        }

        let faqStructuredData = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                "@type": "Question",
                "name": response.data.data[0].attributes.Question,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": response.data.data[0].attributes.Answer
                }
            }]
        }

        // Related Products
        let relatedProducts = []
        let queryObjectRelatedProducts: any = {
            pagination: {
                page: 1,
                pageSize: 4
            },
            filters: {
                Collection: {
                    Link: {$eq: 'honey'}
                }
            },
            sort: ['Views:desc'],
        }
        let queryRelatedProducts = qs.stringify(queryObjectRelatedProducts, {encodeValuesOnly: true,});
        try {
            const responseRelatedProducts = await strapi.getProductsList(queryRelatedProducts);
            if (responseRelatedProducts.status == 200 && responseRelatedProducts.data && responseRelatedProducts.data.data) {
                relatedProducts = responseRelatedProducts.data.data;
            }
        } catch (e) {

        }
        return {props: {FAQ: response.data.data[0].attributes, seoDetails, faqStructuredData, relatedProducts}}
    }
    return {
        notFound: true,
    }
}

export default ConsumerCareCategoryQuestionAnswer;
